/**
 * Student Projects Configuration
 *
 * Projects are compilations of sentences from multiple lessons/pages.
 * Students complete all sentences in a project as a larger assignment.
 *
 * When adding a new project, update BOTH this file AND backend/features/lessons/data/projectsConfig.js.
 * backend/__tests__/critical-flows.test.js will fail if they diverge.
 */

import { findLesson } from './lessonsRegistry.js';
import { getSentenceItems } from './itemsHelper.js';
import { normalizeCourseId } from '../utils/courseNormalization.js';

export const projectsConfig = {
  // Project ID -> Project definition
  'southstreet-b3-project1': {
    id: 'southstreet-b3-project1',
    name: 'South Street B3 Project 1',
    displayName: 'South Street Book 3 综合练习',
    topic: 'southstreet',
    batch: 'b3',
    // Pages/lessons to include (in order)
    pages: ['001', '002', '003', '005', '006', '007'],
    // No reviews for projects
    hasReviews: false,
  },
  'southstreet-b3-p1': {
    id: 'southstreet-b3-p1',
    name: 'South Street B3 Project 1',
    displayName: 'South Street Book 3 综合练习: 第1-5课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['001', '002', '003', '005'],
    hasReviews: false,
  },
  'southstreet-b3-p2': {
    id: 'southstreet-b3-p2',
    name: 'South Street B3 Project 2',
    displayName: 'South Street Book 3 综合练习: 第6-11课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['006', '007', '009', '010', '011'],
    hasReviews: false,
  },
  'southstreet-b3-p3': {
    id: 'southstreet-b3-p3',
    name: 'South Street B3 Project 3',
    displayName: 'South Street Book 3 综合练习: 第12-18课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['012', '014', '015', '017', '018'],
    hasReviews: false,
  },
  'southstreet-b3-p4': {
    id: 'southstreet-b3-p4',
    name: 'South Street B3 Project 4',
    displayName: 'South Street Book 3 综合练习: 第19-25课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['019', '021', '022', '023', '025'],
    hasReviews: false,
  },
  'southstreet-b3-p5': {
    id: 'southstreet-b3-p5',
    name: 'South Street B3 Project 5',
    displayName: 'South Street Book 3 综合练习: 第26-32课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['026', '028', '029', '030', '032'],
    hasReviews: false,
  },
  'southstreet-b3-p6': {
    id: 'southstreet-b3-p6',
    name: 'South Street B3 Project 6',
    displayName: 'South Street Book 3 综合练习: 第33-38课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['033', '035', '036', '037', '038'],
    hasReviews: false,
  },
  'southstreet-b3-p7': {
    id: 'southstreet-b3-p7',
    name: 'South Street B3 Project 7',
    displayName: 'South Street Book 3 综合练习: 第40-45课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['040', '041', '042', '044', '045'],
    hasReviews: false,
  },
  'southstreet-b3-p8': {
    id: 'southstreet-b3-p8',
    name: 'South Street B3 Project 8',
    displayName: 'South Street Book 3 综合练习: 第46-51课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['046', '047', '048', '049', '051'],
    hasReviews: false,
  },
  'southstreet-b3-p9': {
    id: 'southstreet-b3-p9',
    name: 'South Street B3 Project 9',
    displayName: 'South Street Book 3 综合练习: 第52-58课',
    topic: 'southstreet',
    batch: 'b3',
    pages: ['052', '053', '055', '056', '057', '058'],
    hasReviews: false,
  },
  'monkeyking-b2-wukong-vs-erlang': {
    id: 'monkeyking-b2-wukong-vs-erlang',
    name: 'Monkey King B2 — Wukong vs Erlang',
    displayName: '西游记 Book 2: 大战二郎神',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['004', '005', '006', '007', '008', '009', '010', '011', '012', '013', '014', '015'],
    hasReviews: false,
  },
  'monkeyking-b2-p16-19': {
    id: 'monkeyking-b2-p16-19',
    name: 'Monkey King B2 — Pages 16-19',
    displayName: '西游记 Book 2: 第74-77课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['016', '017', '018', '019'],
    hasReviews: false,
  },
  'monkeyking-b2-p19-29': {
    id: 'monkeyking-b2-p19-29',
    name: 'Monkey King B2 — Pages 19-29',
    displayName: '西游记 Book 2: 第77-87课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['019', '020', '021', '022', '023', '024', '025', '026', '027', '028', '029'],
    hasReviews: false,
  },
  'monkeyking-b2-p20-23': {
    id: 'monkeyking-b2-p20-23',
    name: 'Monkey King B2 — Pages 20-23',
    displayName: '西游记 Book 2: 第78-81课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['020', '021', '022', '023'],
    hasReviews: false,
  },
  'monkeyking-b2-p24-27': {
    id: 'monkeyking-b2-p24-27',
    name: 'Monkey King B2 — Pages 24-27',
    displayName: '西游记 Book 2: 第82-85课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['024', '025', '026', '027'],
    hasReviews: false,
  },
  'monkeyking-b2-p28-31': {
    id: 'monkeyking-b2-p28-31',
    name: 'Monkey King B2 — Pages 28-31',
    displayName: '西游记 Book 2: 第86-89课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['028', '029', '030', '031'],
    hasReviews: false,
  },
  'monkeyking-b2-p32-35': {
    id: 'monkeyking-b2-p32-35',
    name: 'Monkey King B2 — Pages 32-35',
    displayName: '西游记 Book 2: 第90-93课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['032', '033', '034', '035'],
    hasReviews: false,
  },
  'monkeyking-b2-p36-39': {
    id: 'monkeyking-b2-p36-39',
    name: 'Monkey King B2 — Pages 36-39',
    displayName: '西游记 Book 2: 第94-97课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['036', '037', '038', '039'],
    hasReviews: false,
  },
  'monkeyking-b2-p40-43': {
    id: 'monkeyking-b2-p40-43',
    name: 'Monkey King B2 — Pages 40-43',
    displayName: '西游记 Book 2: 第98-101课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['040', '041', '042', '043'],
    hasReviews: false,
  },
  'monkeyking-b2-p44-47': {
    id: 'monkeyking-b2-p44-47',
    name: 'Monkey King B2 — Pages 44-47',
    displayName: '西游记 Book 2: 第102-105课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['044', '045', '046', '047'],
    hasReviews: false,
  },
  'monkeyking-b2-p48-51': {
    id: 'monkeyking-b2-p48-51',
    name: 'Monkey King B2 — Pages 48-51',
    displayName: '西游记 Book 2: 第106-109课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['048', '049', '050', '051'],
    hasReviews: false,
  },
  'monkeyking-b2-p52-53': {
    id: 'monkeyking-b2-p52-53',
    name: 'Monkey King B2 — Pages 52-53',
    displayName: '西游记 Book 2: 第110-111课',
    topic: 'monkeyking',
    batch: 'b2',
    pages: ['052', '053'],
    hasReviews: false,
  },
  'monkeyking-b3-p1-4': {
    id: 'monkeyking-b3-p1-4',
    name: 'Monkey King B3 — Pages 1-4',
    displayName: '西游记 Book 3: 第112-115课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['001', '002', '003', '004'],
    hasReviews: false,
  },
  'monkeyking-b3-p5-9': {
    id: 'monkeyking-b3-p5-9',
    name: 'Monkey King B3 — Pages 5-9',
    displayName: '西游记 Book 3: 第116-120课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['005', '006', '007', '008', '009'],
    hasReviews: false,
  },
  'monkeyking-b3-p10-14': {
    id: 'monkeyking-b3-p10-14',
    name: 'Monkey King B3 — Pages 10-14',
    displayName: '西游记 Book 3: 第121-125课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['010', '011', '012', '013', '014'],
    hasReviews: false,
  },
  'monkeyking-b3-p15-19': {
    id: 'monkeyking-b3-p15-19',
    name: 'Monkey King B3 — Pages 15-19',
    displayName: '西游记 Book 3: 第126-130课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['015', '016', '017', '018', '019'],
    hasReviews: false,
  },
  'monkeyking-b3-p20-24': {
    id: 'monkeyking-b3-p20-24',
    name: 'Monkey King B3 — Pages 20-24',
    displayName: '西游记 Book 3: 第131-135课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['020', '021', '022', '023', '024'],
    hasReviews: false,
  },
  'monkeyking-b3-p25-29': {
    id: 'monkeyking-b3-p25-29',
    name: 'Monkey King B3 — Pages 25-29',
    displayName: '西游记 Book 3: 第136-140课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['025', '026', '027', '028', '029'],
    hasReviews: false,
  },
  'monkeyking-b3-p30-34': {
    id: 'monkeyking-b3-p30-34',
    name: 'Monkey King B3 — Pages 30-34',
    displayName: '西游记 Book 3: 第141-145课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['030', '031', '032', '033', '034'],
    hasReviews: false,
  },
  'monkeyking-b3-p35-39': {
    id: 'monkeyking-b3-p35-39',
    name: 'Monkey King B3 — Pages 35-39',
    displayName: '西游记 Book 3: 第146-150课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['035', '036', '037', '038', '039'],
    hasReviews: false,
  },
  'monkeyking-b3-p40-44': {
    id: 'monkeyking-b3-p40-44',
    name: 'Monkey King B3 — Pages 40-44',
    displayName: '西游记 Book 3: 第151-155课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['040', '041', '042', '043', '044'],
    hasReviews: false,
  },
  'monkeyking-b3-p45-49': {
    id: 'monkeyking-b3-p45-49',
    name: 'Monkey King B3 — Pages 45-49',
    displayName: '西游记 Book 3: 第156-160课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['045', '046', '047', '048', '049'],
    hasReviews: false,
  },
  'monkeyking-b3-p50-54': {
    id: 'monkeyking-b3-p50-54',
    name: 'Monkey King B3 — Pages 50-54',
    displayName: '西游记 Book 3: 第161-165课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['050', '051', '052', '053', '054'],
    hasReviews: false,
  },
  'monkeyking-b3-p55-59': {
    id: 'monkeyking-b3-p55-59',
    name: 'Monkey King B3 — Pages 55-59',
    displayName: '西游记 Book 3: 第166-170课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['055', '056', '057', '058', '059'],
    hasReviews: false,
  },
  'monkeyking-b3-p60-65': {
    id: 'monkeyking-b3-p60-65',
    name: 'Monkey King B3 — Pages 60-65',
    displayName: '西游记 Book 3: 第171-176课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['060', '061', '062', '063', '064', '065'],
    hasReviews: false,
  },
  'monkeyking-b3-p37-48': {
    id: 'monkeyking-b3-p37-48',
    name: 'Monkey King B3 — Pages 37-48',
    displayName: '西游记 Book 3: 第148-159课',
    topic: 'monkeyking',
    batch: 'b3',
    pages: ['037', '038', '039', '040', '041', '042', '043', '044', '045', '046', '047', '048'],
    hasReviews: false,
  },
  // Mkk b4 (class 30, from 2026-10-11): blocks 1-4, then 5s; the leftover lessons join the last block.
  'monkeyking-b4-p1-4': {
    id: 'monkeyking-b4-p1-4',
    name: 'Monkey King B4 — Pages 1-4',
    displayName: '西游记 Book 4: 第177-180课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['001', '002', '003', '004'],
    hasReviews: false,
  },
  'monkeyking-b4-p5-9': {
    id: 'monkeyking-b4-p5-9',
    name: 'Monkey King B4 — Pages 5-9',
    displayName: '西游记 Book 4: 第181-185课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['005', '006', '007', '008', '009'],
    hasReviews: false,
  },
  'monkeyking-b4-p10-14': {
    id: 'monkeyking-b4-p10-14',
    name: 'Monkey King B4 — Pages 10-14',
    displayName: '西游记 Book 4: 第186-190课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['010', '011', '012', '013', '014'],
    hasReviews: false,
  },
  'monkeyking-b4-p15-19': {
    id: 'monkeyking-b4-p15-19',
    name: 'Monkey King B4 — Pages 15-19',
    displayName: '西游记 Book 4: 第191-195课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['015', '016', '017', '018', '019'],
    hasReviews: false,
  },
  'monkeyking-b4-p20-24': {
    id: 'monkeyking-b4-p20-24',
    name: 'Monkey King B4 — Pages 20-24',
    displayName: '西游记 Book 4: 第196-200课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['020', '021', '022', '023', '024'],
    hasReviews: false,
  },
  'monkeyking-b4-p25-29': {
    id: 'monkeyking-b4-p25-29',
    name: 'Monkey King B4 — Pages 25-29',
    displayName: '西游记 Book 4: 第201-205课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['025', '026', '027', '028', '029'],
    hasReviews: false,
  },
  'monkeyking-b4-p30-34': {
    id: 'monkeyking-b4-p30-34',
    name: 'Monkey King B4 — Pages 30-34',
    displayName: '西游记 Book 4: 第206-210课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['030', '031', '032', '033', '034'],
    hasReviews: false,
  },
  'monkeyking-b4-p35-39': {
    id: 'monkeyking-b4-p35-39',
    name: 'Monkey King B4 — Pages 35-39',
    displayName: '西游记 Book 4: 第211-215课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['035', '036', '037', '038', '039'],
    hasReviews: false,
  },
  'monkeyking-b4-p40-44': {
    id: 'monkeyking-b4-p40-44',
    name: 'Monkey King B4 — Pages 40-44',
    displayName: '西游记 Book 4: 第216-220课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['040', '041', '042', '043', '044'],
    hasReviews: false,
  },
  'monkeyking-b4-p45-49': {
    id: 'monkeyking-b4-p45-49',
    name: 'Monkey King B4 — Pages 45-49',
    displayName: '西游记 Book 4: 第221-225课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['045', '046', '047', '048', '049'],
    hasReviews: false,
  },
  'monkeyking-b4-p50-54': {
    id: 'monkeyking-b4-p50-54',
    name: 'Monkey King B4 — Pages 50-54',
    displayName: '西游记 Book 4: 第226-230课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['050', '051', '052', '053', '054'],
    hasReviews: false,
  },
  'monkeyking-b4-p55-59': {
    id: 'monkeyking-b4-p55-59',
    name: 'Monkey King B4 — Pages 55-59',
    displayName: '西游记 Book 4: 第231-235课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['055', '056', '057', '058', '059'],
    hasReviews: false,
  },
  'monkeyking-b4-p60-64': {
    id: 'monkeyking-b4-p60-64',
    name: 'Monkey King B4 — Pages 60-64',
    displayName: '西游记 Book 4: 第236-240课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['060', '061', '062', '063', '064'],
    hasReviews: false,
  },
  'monkeyking-b4-p65-69': {
    id: 'monkeyking-b4-p65-69',
    name: 'Monkey King B4 — Pages 65-69',
    displayName: '西游记 Book 4: 第241-245课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['065', '066', '067', '068', '069'],
    hasReviews: false,
  },
  'monkeyking-b4-p70-74': {
    id: 'monkeyking-b4-p70-74',
    name: 'Monkey King B4 — Pages 70-74',
    displayName: '西游记 Book 4: 第246-250课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['070', '071', '072', '073', '074'],
    hasReviews: false,
  },
  'monkeyking-b4-p75-81': {
    id: 'monkeyking-b4-p75-81',
    name: 'Monkey King B4 — Pages 75-81',
    displayName: '西游记 Book 4: 第251-257课',
    topic: 'monkeyking',
    batch: 'b4',
    pages: ['075', '076', '077', '078', '079', '080', '081'],
    hasReviews: false,
  },
  // Whole-book projects ("整本书"): every lesson of one Piggy book, one combined recording.
  // Assigned from the quick-assign modal's 整本书 tab (wholeBook: true).
  'piggy-b1-p1-13': {
    id: 'piggy-b1-p1-13',
    name: 'Piggy B1 — Whole Book',
    displayName: '🐷 I Love My New Toy!《我超爱我的新玩具!》',
    topic: 'piggy',
    batch: 'b1',
    pages: ['001', '002', '003', '004', '005', '006', '007', '008', '009', '010', '011', '012', '013'],
    hasReviews: false,
    wholeBook: true,
  },
  'piggy-b2-p1-14': {
    id: 'piggy-b2-p1-14',
    name: 'Piggy B2 — Whole Book',
    displayName: '🐷 I Am Going!《我要走了!》',
    topic: 'piggy',
    batch: 'b2',
    pages: ['001', '002', '003', '004', '005', '006', '007', '008', '009', '010', '011', '012', '013', '014'],
    hasReviews: false,
    wholeBook: true,
  },
  'piggy-b3-p1-13': {
    id: 'piggy-b3-p1-13',
    name: 'Piggy B3 — Whole Book',
    displayName: '🐷 I Really Like Slop!《我真的很喜欢泔水!》',
    topic: 'piggy',
    batch: 'b3',
    pages: ['001', '002', '003', '004', '005', '006', '007', '008', '009', '010', '011', '012', '013'],
    hasReviews: false,
    wholeBook: true,
  },
  'piggy-b4-p1-14': {
    id: 'piggy-b4-p1-14',
    name: 'Piggy B4 — Whole Book',
    displayName: '🐷 Can I Play Too?《我能一起玩吗?》',
    topic: 'piggy',
    batch: 'b4',
    pages: ['001', '002', '003', '004', '005', '006', '007', '008', '009', '010', '011', '012', '013', '014'],
    hasReviews: false,
    wholeBook: true,
  },
  'piggy-b5-p1-13': {
    id: 'piggy-b5-p1-13',
    name: 'Piggy B5 — Whole Book',
    displayName: '🐷 Are You Ready To Play Outside?《你准备好出去玩了吗?》',
    topic: 'piggy',
    batch: 'b5',
    pages: ['001', '002', '003', '004', '005', '006', '007', '008', '009', '010', '011', '012', '013'],
    hasReviews: false,
    wholeBook: true,
  },
  'piggy-b6-p1-13': {
    id: 'piggy-b6-p1-13',
    name: 'Piggy B6 — Whole Book',
    displayName: '🐷 Should I Share My Ice Cream?《我该分享我的冰激凌吗?》',
    topic: 'piggy',
    batch: 'b6',
    pages: ['001', '002', '003', '004', '005', '006', '007', '008', '009', '010', '011', '012', '013'],
    hasReviews: false,
    wholeBook: true,
  },
  'piggy-b7-p1-14': {
    id: 'piggy-b7-p1-14',
    name: 'Piggy B7 — Whole Book',
    displayName: '🐷 Waiting Is Not Easy!《等待可真不容易!》',
    topic: 'piggy',
    batch: 'b7',
    pages: ['001', '002', '003', '004', '005', '006', '007', '008', '009', '010', '011', '012', '013', '014'],
    hasReviews: false,
    wholeBook: true,
  },
  'piggy-b8-p1-14': {
    id: 'piggy-b8-p1-14',
    name: 'Piggy B8 — Whole Book',
    displayName: '🐷 My New Friend Is So Fun!《我的新朋友真有趣!》',
    topic: 'piggy',
    batch: 'b8',
    pages: ['001', '002', '003', '004', '005', '006', '007', '008', '009', '010', '011', '012', '013', '014'],
    hasReviews: false,
    wholeBook: true,
  },
  'piggy-b9-p1-15': {
    id: 'piggy-b9-p1-15',
    name: 'Piggy B9 — Whole Book',
    displayName: '🐷 There Is a Bird on Your Head!《你头上有一只鸟!》',
    topic: 'piggy',
    batch: 'b9',
    pages: ['001', '002', '003', '004', '005', '006', '007', '008', '009', '010', '011', '012', '013', '014', '015'],
    hasReviews: false,
    wholeBook: true,
  },
  // Whole-song projects ("整首歌", same wholeBook flag): one per /qr/songs song, the
  // child sings the whole song in one video (or one recording). Same 整本书 tab, labelled 整首歌.
  'songs-b1-song-001': {
    id: 'songs-b1-song-001',
    name: 'Songs — Happy Birthday',
    displayName: '🎵 Happy Birthday',
    topic: 'songs',
    batch: 'b1',
    pages: ['001'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-002': {
    id: 'songs-b1-song-002',
    name: 'Songs — Walking Walking',
    displayName: '🎵 Walking Walking',
    topic: 'songs',
    batch: 'b1',
    pages: ['002'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-003': {
    id: 'songs-b1-song-003',
    name: 'Songs — Baby Shark',
    displayName: '🎵 Baby Shark',
    topic: 'songs',
    batch: 'b1',
    pages: ['003'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-004': {
    id: 'songs-b1-song-004',
    name: 'Songs — Opposites',
    displayName: '🎵 Opposites',
    topic: 'songs',
    batch: 'b1',
    pages: ['004'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-005': {
    id: 'songs-b1-song-005',
    name: 'Songs — 10 Little Dinosaurs',
    displayName: '🎵 10 Little Dinosaurs',
    topic: 'songs',
    batch: 'b1',
    pages: ['005'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-006': {
    id: 'songs-b1-song-006',
    name: 'Songs — This Is a Happy Face',
    displayName: '🎵 This Is a Happy Face',
    topic: 'songs',
    batch: 'b1',
    pages: ['006'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-007': {
    id: 'songs-b1-song-007',
    name: 'Songs — The Alphabet Song',
    displayName: '🎵 The Alphabet Song',
    topic: 'songs',
    batch: 'b1',
    pages: ['007'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-008': {
    id: 'songs-b1-song-008',
    name: 'Songs — Positions',
    displayName: '🎵 Positions',
    topic: 'songs',
    batch: 'b1',
    pages: ['008'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-009': {
    id: 'songs-b1-song-009',
    name: 'Songs — I Can Sing a Rainbow',
    displayName: '🎵 I Can Sing a Rainbow',
    topic: 'songs',
    batch: 'b1',
    pages: ['009'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-010': {
    id: 'songs-b1-song-010',
    name: 'Songs — Apple Round',
    displayName: '🎵 Apple Round',
    topic: 'songs',
    batch: 'b1',
    pages: ['010'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-011': {
    id: 'songs-b1-song-011',
    name: 'Songs — Days of the Week',
    displayName: '🎵 Days of the Week',
    topic: 'songs',
    batch: 'b1',
    pages: ['011'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-012': {
    id: 'songs-b1-song-012',
    name: 'Songs — Hello! Hello!',
    displayName: '🎵 Hello! Hello!',
    topic: 'songs',
    batch: 'b1',
    pages: ['012'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-013': {
    id: 'songs-b1-song-013',
    name: "Songs — If You're Happy",
    displayName: "🎵 If You're Happy",
    topic: 'songs',
    batch: 'b1',
    pages: ['013'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-014': {
    id: 'songs-b1-song-014',
    name: 'Songs — 12 Months of the Year',
    displayName: '🎵 12 Months of the Year',
    topic: 'songs',
    batch: 'b1',
    pages: ['014'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-015': {
    id: 'songs-b1-song-015',
    name: 'Songs — Head Shoulders',
    displayName: '🎵 Head Shoulders',
    topic: 'songs',
    batch: 'b1',
    pages: ['015'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-016': {
    id: 'songs-b1-song-016',
    name: "Songs — How's the Weather",
    displayName: "🎵 How's the Weather",
    topic: 'songs',
    batch: 'b1',
    pages: ['016'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-017': {
    id: 'songs-b1-song-017',
    name: 'Songs — This That',
    displayName: '🎵 This That',
    topic: 'songs',
    batch: 'b1',
    pages: ['017'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-018': {
    id: 'songs-b1-song-018',
    name: 'Songs — This Is the Way',
    displayName: '🎵 This Is the Way',
    topic: 'songs',
    batch: 'b1',
    pages: ['018'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-019': {
    id: 'songs-b1-song-019',
    name: 'Songs — Brown Bear',
    displayName: '🎵 Brown Bear',
    topic: 'songs',
    batch: 'b1',
    pages: ['019'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-020': {
    id: 'songs-b1-song-020',
    name: 'Songs — My Heart',
    displayName: '🎵 My Heart',
    topic: 'songs',
    batch: 'b1',
    pages: ['020'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-021': {
    id: 'songs-b1-song-021',
    name: 'Songs — I Am Here',
    displayName: '🎵 I Am Here',
    topic: 'songs',
    batch: 'b1',
    pages: ['021'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-022': {
    id: 'songs-b1-song-022',
    name: 'Songs — Do You Like Broccoli?',
    displayName: '🎵 Do You Like Broccoli?',
    topic: 'songs',
    batch: 'b1',
    pages: ['022'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-023': {
    id: 'songs-b1-song-023',
    name: 'Songs — Roomba Room',
    displayName: '🎵 Roomba Room',
    topic: 'songs',
    batch: 'b1',
    pages: ['023'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-024': {
    id: 'songs-b1-song-024',
    name: 'Songs — I Have a Pencil',
    displayName: '🎵 I Have a Pencil',
    topic: 'songs',
    batch: 'b1',
    pages: ['024'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-025': {
    id: 'songs-b1-song-025',
    name: 'Songs — The Wheels on the Bus',
    displayName: '🎵 The Wheels on the Bus',
    topic: 'songs',
    batch: 'b1',
    pages: ['025'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-026': {
    id: 'songs-b1-song-026',
    name: 'Songs — Twinkle Twinkle Little Star',
    displayName: '🎵 Twinkle Twinkle Little Star',
    topic: 'songs',
    batch: 'b1',
    pages: ['026'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-027': {
    id: 'songs-b1-song-027',
    name: 'Songs — If I Were a Ghost',
    displayName: '🎵 If I Were a Ghost',
    topic: 'songs',
    batch: 'b1',
    pages: ['027'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-028': {
    id: 'songs-b1-song-028',
    name: 'Songs — 5 Little Ducks',
    displayName: '🎵 5 Little Ducks',
    topic: 'songs',
    batch: 'b1',
    pages: ['028'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-029': {
    id: 'songs-b1-song-029',
    name: 'Songs — 5 Little Monsters',
    displayName: '🎵 5 Little Monsters',
    topic: 'songs',
    batch: 'b1',
    pages: ['029'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-030': {
    id: 'songs-b1-song-030',
    name: 'Songs — Rain Rain Go Away',
    displayName: '🎵 Rain Rain Go Away',
    topic: 'songs',
    batch: 'b1',
    pages: ['030'],
    hasReviews: false,
    wholeBook: true,
  },
  'songs-b1-song-031': {
    id: 'songs-b1-song-031',
    name: 'Songs — A is for Apple',
    displayName: '🎵 A is for Apple',
    topic: 'songs',
    batch: 'b1',
    pages: ['031'],
    hasReviews: false,
    wholeBook: true,
  },
};

/**
 * Get project config by ID
 * @param {string} projectId
 * @returns {object|null}
 */
export const getProjectConfig = (projectId) => {
  return projectsConfig[projectId] || null;
};

/**
 * Get all projects for a topic/batch
 * @param {string} topic
 * @param {string} batch
 * @returns {object[]}
 */
export const getProjectsForBatch = (topic, batch) => {
  return Object.values(projectsConfig).filter(
    p => p.topic === topic && p.batch === batch
  );
};

/**
 * Get the whole-book ("整本书") projects for a topic, in book order
 * @param {string} topic
 * @returns {object[]}
 */
export const getWholeBookProjects = (topic) => {
  return Object.values(projectsConfig).filter(p => p.wholeBook && p.topic === topic);
};

/**
 * What a whole-book project is called for a topic: songs are sung one at a time
 * @param {string} topic
 * @returns {'整首歌'|'整本书'}
 */
export const getWholeUnitLabel = (topic) => (topic === 'songs' ? '整首歌' : '整本书');

/**
 * Get all sentences for a project, combined from all pages
 * Uses the unified lesson config for correct video timestamps
 * Each sentence gets a unique projectSentenceId for submission tracking
 * @param {string} projectId
 * @returns {Promise<object[]>} Array of sentences with page info
 */
export const getProjectSentences = async (projectId) => {
  const project = getProjectConfig(projectId);
  if (!project) return [];

  // Normalize topic name (handle course aliases)
  const normalizedTopic = normalizeCourseId(project.topic) || project.topic;

  const allSentences = [];
  let globalIndex = 1;

  // Collect sentences from each lesson/page in order
  for (const lessonNumber of project.pages) {
    // Find the lesson in the unified registry (async)
    const lesson = await findLesson(normalizedTopic, project.batch, lessonNumber);
    if (!lesson) continue;

    // Get sentence items from the lesson using the helper
    const sentenceItems = getSentenceItems(lesson);
    if (!sentenceItems?.length) continue;

    for (const sentence of sentenceItems) {
      allSentences.push({
        ...sentence,
        // 's'-prefixed, like every other item-id producer — see canonicalSentenceId
        // in src/utils/itemTypes.js. Was a BARE index ("17") until 2026-08-18;
        // history is backfilled by canonicalizeBareItemIds in backend/database/migrations.js.
        // Still a string: submission.sentenceId is TEXT, and numeric coercion breaks
        // the completedRecordings[item.id] lookup.
        id: `s${globalIndex}`,
        originalPage: lessonNumber,
        originalId: sentence.id,
        pageLabel: `Page ${parseInt(lessonNumber, 10)}`,
        type: 'sentence',
        repeats: sentence.repeats || 3,
      });
      globalIndex++;
    }
  }

  return allSentences;
};

/**
 * Get total sentence count for a project
 * @param {string} projectId
 * @returns {Promise<number>}
 */
export const getProjectSentenceCount = async (projectId) => {
  const sentences = await getProjectSentences(projectId);
  return sentences.length;
};

/**
 * Get ordered array of unique video configs for a project (one per distinct HLS URL).
 * Each entry includes startAt/endAt — the first/last sentence timestamps for that episode —
 * so the player can skip intros and outros when auto-advancing between episodes.
 * @param {string} projectId
 * @returns {Promise<Array<{hls: string, thumb: string, startAt: number, endAt: number}>>}
 */
export const getProjectVideos = async (projectId) => {
  const project = getProjectConfig(projectId);
  if (!project?.pages?.length) return [];
  const normalizedTopic = normalizeCourseId(project.topic) || project.topic;
  const seen = new Map(); // hls → { hls, thumb, startAt, endAt }

  for (const lessonNumber of project.pages) {
    const lesson = await findLesson(normalizedTopic, project.batch, lessonNumber);
    if (!lesson?.videos?.sentences) continue;
    const { hls, thumb } = lesson.videos.sentences;
    if (!hls) continue;
    const sentences = getSentenceItems(lesson);
    if (!sentences?.length) continue;
    if (!seen.has(hls)) {
      seen.set(hls, { hls, thumb, startAt: sentences[0].videoStart, endAt: sentences[sentences.length - 1].videoEnd });
    } else {
      seen.get(hls).endAt = sentences[sentences.length - 1].videoEnd;
    }
  }
  return [...seen.values()];
};

/**
 * Get the sentences video for a project
 * Uses the first page's lesson to get the video URL
 * @param {string} projectId
 * @returns {Promise<object|null>} { hls, thumb } or null
 */
export const getProjectVideo = async (projectId) => {
  const project = getProjectConfig(projectId);
  if (!project || !project.pages?.length) return null;

  // Get the first page's lesson number
  const firstPage = project.pages[0];
  const normalizedTopic = normalizeCourseId(project.topic) || project.topic;

  // Find the lesson in the registry (async)
  const lesson = await findLesson(normalizedTopic, project.batch, firstPage);
  if (!lesson?.videos?.sentences) return null;

  return lesson.videos.sentences;
};
